import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { EMPTY_VALUE, FieldValue } from "../../../Schema";


export type User = {
  userId: string;
  user?: string; // in some cases, userId can be under `user` field
  id?: string;
  email?: string;
  name?: string;
  givenName?: string;
  familyName?: string;
  site?: string;
  isAdmin?: boolean;
}

export const listUsersQuery: Source<User[]> = {
  graphql: parse(`
    query listDigitalLabInstrumentRepositoryUsers($nextToken: String) {
      listDigitalLabInstrumentRepositoryUsers(
        limit: 10000,
        nextToken: $nextToken
      ) {
        items {
          email
          familyName
          givenName
          name
          userId
        }
        nextToken
      }
    }
  `),
  dynamodb: {
    // Keyed by userId with nothing to group by, so listing every user is a scan — as it is
    // on the GraphQL side, where the resolver has no key argument to narrow with either.
    operation: DynamoDbOperations.SCAN,
    table: DynamoDbTables.USERS,
  },
};

export const getUsers = async (client: SchemaClient): Promise<User[] | typeof EMPTY_VALUE> => {
  return await client.queryList(listUsersQuery);
};

export const getAndProcessUsers = async (client: SchemaClient): Promise<User[]> => {
  const users = await getUsers(client);
  return users?.map((user: User) => ({
    email: user.email,
    familyName: user.familyName,
    givenName: user.givenName,
    name: user.name,
    site: user.site,
    userId: user.userId,
  })) ?? [];
}

export const isUserValue = (value: FieldValue): value is User => {
  return typeof value === "object" &&
    value !== null &&
    (
      "userId" in value || // proper value should have `userId` field
      "user" in value // in some cases, userId can be under `user` field
    );
}